import { render, staticRenderFns } from "./itemTitle.vue?vue&type=template&id=02673520&"
import script from "./itemTitle.vue?vue&type=script&lang=js&"
export * from "./itemTitle.vue?vue&type=script&lang=js&"
import style0 from "./itemTitle.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports